'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$15() {
  this.awY = null;
  this.awZ = false;
}
export { $c_Lpresto_AgentView$$anon$15 as $c_Lpresto_AgentView$$anon$15 };
$p = $c_Lpresto_AgentView$$anon$15.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$15;
/** @constructor */
function $h_Lpresto_AgentView$$anon$15() {
}
export { $h_Lpresto_AgentView$$anon$15 as $h_Lpresto_AgentView$$anon$15 };
$h_Lpresto_AgentView$$anon$15.prototype = $p;
$p.P = (function() {
  if ((!this.awZ)) {
    this.awY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.awZ = true;
  }
  return this.awY;
});
var $d_Lpresto_AgentView$$anon$15 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$15, "presto.AgentView$$anon$15", ({
  DJ: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AgentView$$anon$15 as $d_Lpresto_AgentView$$anon$15 };
//# sourceMappingURL=presto.-Agent-View$$anon$15.js.map
